
// @ts-nocheck
import locale__vercel_path0_i18n_src_langs_fr_CH_ts from "../i18n/src/langs/fr-CH.ts?hash=546d2414&locale=fr";
import locale__vercel_path0_i18n_src_langs_en_GB_ts from "../i18n/src/langs/en-GB.ts?hash=2299fcbe&locale=en";
import locale__vercel_path0_i18n_src_langs_de_DE_ts from "../i18n/src/langs/de-DE.ts?hash=099b300c&locale=de";


export const localeCodes =  [
  "fr",
  "en",
  "de"
]

export const localeLoaders = {
  "fr": [{ key: "../i18n/src/langs/fr-CH.ts", load: () => Promise.resolve(locale__vercel_path0_i18n_src_langs_fr_CH_ts), cache: false }],
  "en": [{ key: "../i18n/src/langs/en-GB.ts", load: () => Promise.resolve(locale__vercel_path0_i18n_src_langs_en_GB_ts), cache: false }],
  "de": [{ key: "../i18n/src/langs/de-DE.ts", load: () => Promise.resolve(locale__vercel_path0_i18n_src_langs_de_DE_ts), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../i18n/config.ts?hash=4caee762&config=1" /* webpackChunkName: "__i18n_config_4caee762" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n/config",
  "locales": [
    {
      "code": "fr",
      "language": "fr-CH",
      "localeId": "018de5e8f0187da7878a83c468cbdbbd",
      "files": [
        "/vercel/path0/i18n/src/langs/fr-CH.ts"
      ]
    },
    {
      "code": "en",
      "language": "en-GB",
      "localeId": "018de510ccf773649dd8dfa16b3b54fc",
      "files": [
        "/vercel/path0/i18n/src/langs/en-GB.ts"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "localeId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
      "files": [
        "/vercel/path0/i18n/src/langs/de-DE.ts"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "./i18n/src/langs/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "fr",
    "language": "fr-CH",
    "localeId": "018de5e8f0187da7878a83c468cbdbbd",
    "files": [
      {
        "path": "/vercel/path0/i18n/src/langs/fr-CH.ts"
      }
    ]
  },
  {
    "code": "en",
    "language": "en-GB",
    "localeId": "018de510ccf773649dd8dfa16b3b54fc",
    "files": [
      {
        "path": "/vercel/path0/i18n/src/langs/en-GB.ts"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "localeId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
    "files": [
      {
        "path": "/vercel/path0/i18n/src/langs/de-DE.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
